import { z } from 'zod';

export const enquirySchema = z.object({
    name: z
        .string()
        .min(2, 'Name must be at least 2 characters')
        .max(100, 'Name must be under 100 characters'),
    email: z.string().email('Enter a valid email address'),
    mobile: z
        .string()
        .min(10, 'Enter a valid phone number')
        .max(15, 'Phone number is too long'),
    category: z.string().min(1, 'Please select a category'),
    description: z
        .string()
        .min(10, 'Message must be at least 10 characters')
        .max(2000, 'Message must be under 2000 characters'),
});

export type EnquiryFormData = z.infer<typeof enquirySchema>;
